import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum CaulipuffsInvoiceLineItemKeys {
  itemNumber = 'itemNumber',
  externalItemNumber = 'externalItemNumber',
  description = 'description',
  itemQty = 'itemQty',
  unitPrice = 'unitPrice',
  discountAmount = 'discountAmount',
  discountNote = 'discountNote', // notes about discount
  lineTotal = 'lineTotal',
}

export const caulipuffsInvoiceFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  recipient: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  remittanceInstructions: yup.object().shape({
    routingNumber: yup.string().nullable().optional(),
    accountNumber: yup.string().nullable().optional(),
    bankName: yup.string().nullable().optional(),
    bankAddress: yup.string().nullable().optional(),
    beneficiaryName: yup.string().nullable().optional(),
    beneficiaryAddress: yup.string().nullable().optional(),
    paymentLink: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        description: yup.string().nullable().optional(),
        externalItemNumber: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        discountAmount: yup.string().nullable().optional(),
        discountNote: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type CaulipuffsInvoiceFileData = yup.InferType<typeof caulipuffsInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<CaulipuffsInvoiceFileData>

export const caulipuffsInvoiceFileMappings: RequiredFileData = {
  issuer: {
    companyName: '2cb9a5d4-635a-4ff7-a711-2081fd7a1e68',
    addressLine1: 'e6319ef6-3624-4808-baa6-4bf645f4a6a2',
    phoneNumber: 'ef955af8-eaec-4418-8090-2afa653395b4',
    emailAddress: 'b5f56ad5-b96c-440b-8659-60a36d13ab5a',
  },
  recipient: {
    companyName: '504d6325-5048-409e-aa90-c37fc6159a07',
    addressLine1: '0fe6e34d-98b0-4ca9-b647-7c498a7ea0a7',
    phoneNumber: '118afed0-aeb3-46b7-8171-ccc61654189c',
    emailAddress: '7f0ecb87-73dd-4b7f-a702-41dbe1ac53a2',
  },
  invoiceNumber: 'e4be91db-0d78-418b-8f85-c83fb2e533f4',
  associatedReferenceNumber: '831e7175-062e-42d7-b3d4-8cb8e6424ea0',
  dateIssued: 'c68ddae8-4adf-44a2-abbb-06f319ae3cda',
  dateDue: 'd38b9077-0e5b-462b-a939-c99e0b1963a5',
  paymentTerms: 'f8815cf1-b0ea-4480-9ed7-a4f2ed874f66',
  freightTerms: '791366ea-1d4a-40ff-9012-44089121abd1',
  remittanceInstructions: {
    routingNumber: '209504ec-cc1b-4520-b6e0-51ecd4545695',
    accountNumber: 'ae9283d9-1856-4bff-9dc4-7f32aa52dc20',
    bankName: 'bb7fc774-f419-44c5-855f-938c6ac5e122',
    bankAddress: '5f97aa54-95d7-4922-8c25-62889950031a',
    beneficiaryName: 'ae4176bd-2632-45ce-b05a-b1256d0985ca',
    beneficiaryAddress: 'e4b49a2f-7355-488e-b512-c97163c2b057',
    paymentLink: '3eb775fa-7898-4934-878f-c678ccebcb4d',
  },
  items: [
    {
      itemNumber: null,
      description: 'c23efd62-c6dd-4a34-8615-0eb9c907cb2d',
      externalItemNumber: 'c1776c03-d324-442d-96f5-4d78416e91f1',
      itemQty: '57efd9bd-315f-4862-b6c8-8953be99b499',
      unitPrice: '08e6f538-844f-40f5-8845-5c22c1f94711',
      discountAmount: '2e691c96-cd56-436f-817a-327586392a31',
      discountNote: '0f2d35cc-5b9d-4635-bc59-4f62224f8a1e',
      lineTotal: null,
    },
  ],
  agreement: '5c657147-969f-42fa-9d31-8fcb482c7904',
  comments: 'eff6d7d8-e0a2-468a-b24d-bddff30f458b',
}
